import RouteMap from 'assets/RouteMap.js'
export const CHAT_EMPLOYER_GENERAL = 'EmployerGeneral'
export const CHAT_EMPLOYER_ARTICLES = 'EmployerArticles'

export const usePipedrive = () => {
    const getIdChatEmployerGeneral = () => {
        const language = RouteMap.GetLocaleFromUrl()

        if (language === 'fr') return '6639c208-41fd-4cef-b4ac-eef5e08bfc24'
        if (language === 'nl') return 'e8811ecc-69da-4276-a12e-e376b3d75d40'
        if (language === 'en') return 'e8811ecc-69da-4276-a12e-e376b3d75d40'
    }

    const getIdChatEmployerArticles = () => {
        const language = RouteMap.GetLocaleFromUrl()

        if (language === 'fr') return 'c5bc1af8-fc68-4891-984d-6ec4f25b30df'
        if (language === 'nl') return 'c6db0f6c-b23c-4d17-87c8-44cfae7fa86e'
        if (language === 'en') return 'c6db0f6c-b23c-4d17-87c8-44cfae7fa86e'
    }

    const getChatId = (type) => {
        if (type === CHAT_EMPLOYER_GENERAL) return getIdChatEmployerGeneral()
        if (type === CHAT_EMPLOYER_ARTICLES) return getIdChatEmployerArticles()
    }

    const getUrlEmployersContactForm = () => {
        const baseUrl = 'https://webforms.pipedrive.com/f/'
        const language = RouteMap.GetLocaleFromUrl()
        let formId

        if (language === 'nl') formId = '1wAzLteXvSJ8QxKdlNo2DLjIsGeU3vH8ws3rdbU6br0aEPou7yF3KpMnHNHNhOzu3'
        if (language === 'fr') formId = '31lkg3G3qLbhIGmqOvDICIs56LK6BzwUzLtdi1F2u3sSNbqcv4hcINT7XK7Vr2rEn'
        if (language === 'en') formId = '2VMfCHok5yOrrLEG1wD0UW1zX0uxzOwUTApagaAqxlgJ6pRzl4oFWNCzgxCuD5TRV'

        return baseUrl + formId
    }

    const getUrlEmployersFreeQuoteForm = () => {
        const baseUrl = 'https://webforms.pipedrive.com/f/'
        const language = RouteMap.GetLocaleFromUrl()
        let formId

        if (language === 'nl') formId = '1EjNJaJ7C3Zl95Vk3JnTXs2EFKSQeM03ksOtnRbS4jNfqXmR2wAjnTWYhnCV8hJRh'
        if (language === 'fr') formId = '1roMlItng6ccNxVL34svPOuqy2dpmIPFhiqgLI4MZusFjF7RxCjUifYJfpAxpz7er'
        if (language === 'en') formId = '1DXNHTXjVmIHrQDYCxJgq5XO9oZFoj3O3H5ZJn7Dv6wpZMfDxeDQ3ItaFy29kvj6b'

        return baseUrl + formId
    }

    const getUrlStartupsMeetingForm = () => {
        const baseUrl = 'https://webforms.pipedrive.com/f/'
        const language = RouteMap.GetLocaleFromUrl()
        let formId

        if (language === 'nl') formId = '1Ca1hSwuwXQcZYVhgKOFpblmSXJoNVh6RY5pU0zHIsrpJGaa4RjsOWdUvfHfHMj2r'
        if (language === 'fr') formId = '1E1PBIVJZcqsogE1bjT9FXDwdaO75s9b9b8kBE4DVJwynHfAPtlF07wmqKJLFLJSP'
        if (language === 'en') formId = '31j5EBGzmO9TRpJTXHGlrImQpqfH3Vct45ZTsPnznEqHyPIeBGRPDaxsXDV3DasTN'

        return baseUrl + formId
    }

    const getUrlAcademicServicesForm = () => {
        const baseUrl = 'https://webforms.pipedrive.com/f/'
        const language = RouteMap.GetLocaleFromUrl()
        let formId

        if (language === 'nl') formId = '1CvpJ6TLotCAKtqc4rLj7UWdEXsI8BhiFxxcWziah8vBI0FDIhX6oHKSS1OAfXmev'
        if (language === 'fr') formId = '1wDbs7kAHq0hcB9G5M8gKjJdALIO9kM7npyTllOcSoE3lCW80Soz76funyWaByl6H'
        if (language === 'en') formId = '1C89jyaAvXTF7XOmO5ZLNqbM90Yd6v428HAxYxFv7yiFNxTkxNTeoRi9vtRJjGb9p'

        return baseUrl + formId
    }

    const getUrlSnaklabContactForm = () => {
        const baseUrl = 'https://webforms.pipedrive.com/f/'
        const language = RouteMap.GetLocaleFromUrl()
        let formId

        if (language === 'nl') formId = '1FQ8QmJDs4nHobUQeWvmrGSLpkQslRrlN4lXSmzwvTl3Ts5ohRkQupXQwIXKRVMK7'
        if (language === 'fr') formId = '1wW3nUUGsAgSh7NtniJovjf20yWsBoWE7UsnDEO4JcTKln1RSjaDfTMEmHfHWsUkr'
        if (language === 'en') formId = '1AhFN3GGeWg6FH3ecUn2TTN0UJ9e43jRzjT8wgBwpUQ1uTQYKJOQuhMmxSXSscO5l'

        return baseUrl + formId
    }

    const getUrlIntegrationContactForm = () => {
        const baseUrl = 'https://webforms.pipedrive.com/f/'
        const language = RouteMap.GetLocaleFromUrl()
        let formId

        if (language === 'nl') formId = '1CtascbNN6QjMYhdvE34JrB95g3n7qHLregYwAyweA2kI4XDyiZxhgHF87nktsF4D'
        if (language === 'fr') formId = '2TByGafUCqpgrJzYrknkkjDKWZaFKGgaRQlCRswk7nScZ8YLDepSIhABxUBCfMQfh'
        if (language === 'en') formId = '1r1WWjecGvb2TB0FBhlt46vjtdXnutq7Ac5JclkXqYF9c2DqFPhsN7ovDEy2JWQqn'

        return baseUrl + formId
    }

    const getUrlEmployerArticleContactForm = () => {
        const baseUrl = 'https://webforms.pipedrive.com/f/'
        const language = RouteMap.GetLocaleFromUrl()
        let formId

        if (language === 'nl') formId = '339yXGqtxG72BvUPZ8x9OehYBfTpALW81SS1Dn18YK9Rm8vbfoltrRkXMA507Aij1'
        if (language === 'fr') formId = '1r3ntxheAtPURFkp2nr5cfK2uEkWozw1GB2uQtbv3aooA5i7UIMdF2aLwnzmK4Zy3'
        if (language === 'en') formId = '1r4gSivXpezexD02baV3IRPhw7QVrbyh7BimzsOYvKchkcg6Zu9hio3KjgVYULq15'

        return baseUrl + formId
    }

    const instantiateContactForm = (pipedriveNode) => {
        if (!pipedriveNode) return

        const script = document.createElement('script')
        script.src = 'https://webforms.pipedrive.com/f/loader'
        script.async = true
        pipedriveNode.appendChild(script)
    }

    const instantiateChat = (type) => {
        const chatId = getChatId(type)
        const script = document.createElement('script')
        const script2 = document.createElement('script')
        script.type = 'text/javascript'
        script.innerHTML = `window.pipedriveLeadboosterConfig = {base: 'leadbooster-chat.pipedrive.com',companyId: 6316802,playbookUuid: '${chatId}',version: 2};(function () {var w = window;if (w.LeadBooster) {console.warn('LeadBooster already exists');} else {w.LeadBooster = {q: [],on: function (n, h) {this.q.push({ t: 'o', n: n, h: h });},trigger: function (n) {this.q.push({ t: 't', n: n });},};}})();`
        script.async = true

        script2.src = 'https://leadbooster-chat.pipedrive.com/assets/loader.js'
        script2.async = true

        document.body.appendChild(script)
        document.body.appendChild(script2)
    }

    return {
        getIdChatEmployerGeneral,
        getIdChatEmployerArticles,
        getUrlEmployersContactForm,
        getUrlEmployersFreeQuoteForm,
        getUrlAcademicServicesForm,
        getUrlSnaklabContactForm,
        getUrlStartupsMeetingForm,
        getUrlIntegrationContactForm,
        getUrlEmployerArticleContactForm,
        instantiateContactForm,
        instantiateChat
    }
}
